/** Bump when Terms of Service body changes; users must re-accept. */
export const CURRENT_TERMS_VERSION = '2026-07-01';

export type LegalDocId = 'privacy' | 'terms';

export function legalPathFor(doc: LegalDocId): string {
  return doc === 'privacy' ? '/privacy' : '/terms';
}

export function parseLegalPath(pathname: string): LegalDocId | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/privacy') return 'privacy';
  if (path === '/terms') return 'terms';
  return null;
}
